<div class="w-100 h-100 d-flex" style="max-height: 600px">
  <div class="card card-tall l-364 {{ reverse ? 'card-reverse': ''}}">
    <div class="card-content">
      <ng-container *ngIf="product != 'Baseeta'; else BaseetaImg">
        <div class="card-imageWrapper">
          <img class="card-image" src="assets/images/Illustrations/{{ 'Illustrations.' + product | translate }}"/>
        </div>
      </ng-container>
      <ng-template #BaseetaImg>
        <div class="card-imageWrapper baseeta-container"> <!--style="gap: 56px; align-items: stretch;"-->
          <div class="baseeta-image-container">
            <img class="baseeta-image" src="assets/images/Illustrations/{{ 'Illustrations.' + product | translate }}"/>
          </div>
          <div *ngIf="!isMobile" class="baseetaQR-container">
            <img class="downloadBaseeta-QR" [src]="baseetaAppQRCode"/> 
            <p class="downloadBaseeta-text">{{('DashBoard.Home.ScanToDownload' | translate)}}</p>
          </div>
        </div>
      </ng-template>
      
      <h3 class="text-capitalize card-title">
        <a *ngIf="(product =='PersonalFinance' || product == 'CreditCard') && !IsSignedIn; else otherProducts" [href]="('DashBoard.Home.' + product + 'Link' | translate)" target="_blank" role="button" class="text-decoration-none tooltip" style="color: inherit;">
          {{ 'DashBoard.Home.' + product | translate }}
        </a>
        <ng-template #otherProducts>
          <p>
            {{ 'DashBoard.Home.' + product | translate }}
          </p>
        </ng-template>
      </h3>
      <div class="card-description">
        <p *ngIf="product == 'Baseeta'" [innerHTML]="('DashBoard.Home.'+ product +'Header' | translate)"class="fw-bold pb-3"></p>
        <ul>
          <li [innerHTML]="('DashBoard.Home.'+ product +'0' | translate)"></li>
          <li [innerHTML]="('DashBoard.Home.'+ product +'1' | translate)"></li>
          <li [innerHTML]="('DashBoard.Home.'+ product +'2' | translate)"></li>
        </ul>
        <p *ngIf="product == 'Baseeta' && !isMobile"  [innerHTML]="('DashBoard.Home.DownloadBaseeta' | translate)"class="fw-bold colored pt-3 pb-4 fs-18"></p>
      </div>
    </div>
    <ng-container *ngIf="product != 'Baseeta'; else downloadButton">
      <div class="card-actions" (click)="onApply()" >
        <a routerLink="." class="button button-primary">
          <span>{{ "DashBoard.Home.ApplyNow" | translate }}</span>
        </a>
      </div>
    </ng-container>
    <ng-template #downloadButton>
      <ng-container *ngIf="isMobile">
        <div class="card-actions w-auto {{ !reverse ? 'align-self-end': 'align-self-center'}}" (click)="downloadBaseeta()">
          <a routerLink="." class="button button-primary">
            <span>{{ "DashBoard.Home.DownloadBaseeta" | translate }}</span>
          </a>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>